import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { GuestRequest } from '../components/GuestRequest';
import { Tabs, TabList, Tab, TabPanel } from '../components/Tabs';
export const GuestRequests = () => {
  const {
    bookingId
  } = useParams();
  const navigate = useNavigate();
  // Mock data
  const booking = {
    id: bookingId,
    eventName: 'Summer Club Night',
    tableName: 'VIP Table',
    date: 'Saturday, 15 July 2023'
  };
  // Mock guest requests
  const pendingRequests = [{
    id: 'g1',
    name: 'Sarah Johnson',
    avatar: 'https://randomuser.me/api/portraits/women/12.jpg',
    gender: 'female' as const,
    message: "Hey! Would love to join your table. I'm coming with a friend."
  }, {
    id: 'g2',
    name: 'Michael Smith',
    avatar: 'https://randomuser.me/api/portraits/men/22.jpg',
    gender: 'male' as const,
    message: 'Is there still space available? I can bring drinks!'
  }];
  const approvedRequests = [{
    id: 'g3',
    name: 'Emma Wilson',
    avatar: 'https://randomuser.me/api/portraits/women/33.jpg',
    gender: 'female' as const,
    message: 'Thanks for accepting! Looking forward to it.'
  }];
  const handleBack = () => {
    navigate(-1);
  };
  const handleAccept = (id: string) => {
    // Handle accept logic
    console.log('Accepted guest', id);
  };
  const handleDecline = (id: string) => {
    // Handle decline logic
    console.log('Declined guest', id);
  };
  const handleMessage = (id: string) => {
    // Navigate to chat
    navigate(`/messages/${id}`);
  };
  return <div className="bg-white min-h-screen pb-16" data-id="element-296">
      <Header title="Guest Requests" onBack={handleBack} data-id="element-297" />
      <div className="p-4" data-id="element-298">
        <div className="border border-dashed border-gray-300 rounded-lg p-3 mb-4" data-id="element-299">
          <h2 className="font-medium text-gray-800" data-id="element-300">{booking.eventName}</h2>
          <p className="text-sm text-gray-600" data-id="element-301">
            {booking.tableName} • {booking.date}
          </p>
        </div>
        <Tabs defaultTab="pending" data-id="element-302">
          <TabList data-id="element-303">
            <Tab id="pending" data-id="element-304">Pending ({pendingRequests.length})</Tab>
            <Tab id="approved" data-id="element-305">Approved ({approvedRequests.length})</Tab>
          </TabList>
          <TabPanel id="pending" data-id="element-306">
            {pendingRequests.length > 0 ? pendingRequests.map(request => <GuestRequest key={request.id} {...request} onAccept={() => handleAccept(request.id)} onDecline={() => handleDecline(request.id)} onMessage={() => handleMessage(request.id)} data-id="element-307" />) : <div className="text-center py-8 text-gray-500" data-id="element-308">
                No pending requests
              </div>}
          </TabPanel>
          <TabPanel id="approved" data-id="element-309">
            {approvedRequests.length > 0 ? approvedRequests.map(request => <GuestRequest key={request.id} {...request} onAccept={() => {}} onDecline={() => handleDecline(request.id)} onMessage={() => handleMessage(request.id)} data-id="element-310" />) : <div className="text-center py-8 text-gray-500" data-id="element-311">
                No approved guests yet
              </div>}
          </TabPanel>
        </Tabs>
      </div>
      <Navigation data-id="element-312" />
    </div>;
};